(function () {

    'use strict';

    angular
        .module('app.core')
        .factory('OpenlaneService', [
            'API_CONFIG',
            '$window',
            '$http',
            '$q',
            'DataService',
            OpenlaneService
        ]);

    function OpenlaneService(API_CONFIG, $window, $http, $q, dataService){
        var service = {};
        // Global - executes just once
        service.userContextDeferred = undefined;
        service.search31APISearchContextDeferred = undefined;
        service.ssoTokenAjaxCall = ssoTokenAjaxCall;
        service.initUserInfoContext = initUserInfoContext;
        service.initSearchContext = initSearchContext;
        service.searchContextCallback = searchContextCallback;

        return service;

        // provide the function that accepts the following arguments:
        // f(ssoToken)
        // the internal $.ajax call should not set the error handler
        function ssoTokenAjaxCall(f, errorCallback) {
            if (!errorCallback) {
                errorCallback = function () {
                };
            }
            var ssoToken = dataService.getSsoTokenFromCookie();
            if (angular.isDefined(ssoToken)) {
                f(dataService.getSsoTokenFromCookie()).then(undefined, function() {
                    // the original ajax call failed - trying to get the new token first
                	getSsoToken().then(function (response) {
                        // we have the new token - save it into the cookie and do the initial call again
                        var ssoToken = response.data.token;
                        dataService.setSsoTokenIntoCookie(ssoToken);
                        f(ssoToken).then(undefined, function (response) {
                            // The original ajax call failed again. There is no point getting a new token, fail now
                            errorCallback(response);
                        });
                    },
                    function (response) {
                        // We have failed to get the sso token
                        errorCallback(response);
                    });
                });
            } else {
            	// we have no token, call token service to get a token
            	getSsoToken().then(function (response) {
                    // we have the token - save it into the cookie and do the initial call
                    var ssoToken = response.data.token;
                    dataService.setSsoTokenIntoCookie(ssoToken);
                    f(ssoToken).then(undefined, function (response) {
                        errorCallback(response);
                    });
                },
                function (response) {
                    // We have failed to get the sso token
                    errorCallback(response);
                });
            }
        }

        function getSsoToken() {
            var ssoTokenAjaxData = {
                plId: API_CONFIG.PRIVATE_LABEL_ID
            };
            if (angular.isDefined(API_CONFIG.PROXY_USR) && angular.isDefined(API_CONFIG.PROXY_PAS)) {
                ssoTokenAjaxData.username = API_CONFIG.PROXY_USR;
                ssoTokenAjaxData.password = API_CONFIG.PROXY_PAS;
            }
            return $http({
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'text/plain',
                    'Access-Control-Max-Age': 300
                },
                // IMPORTANT: do not set the xhrFields: { withCredentials: true }, this will set the SSO server cookie and will overwrite the logged user
                url: API_CONFIG.endpoints.SSO_TOKEN_SERVICE_URL,
                method: 'GET',
                params: ssoTokenAjaxData
            });
        }

        // this is a shared component but also is an example of how to use the ssoTokenAjaxCall wrapper function
        function initUserInfoContext() {
            if (service.userContextDeferred) {
                return service.userContextDeferred.promise;
            }

            service.userContextDeferred = $q.defer();
            var userInfoContextDeferred = service.userContextDeferred;

            service.ssoTokenAjaxCall(function (ssoToken) {
                return $http({
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'text/plain',
                        'Access-Control-Max-Age': 300
                    },
                    url: API_CONFIG.endpoints.IMOLA_LOGIN_CONTEXT_WEB_API + 'userinfocontext.json',
                    method: 'GET',
                    params: {
                        'plId': API_CONFIG.PRIVATE_LABEL_ID,
                        'x-openlane-authentication': ssoToken
                    }
                }).then(function (response) {
                    userInfoContextDeferred.resolve(response.data, ssoToken);
                });
            }, function (response) {
                userInfoContextDeferred.reject();
            });

            return userInfoContextDeferred.promise;
        }

        function initSearchContext() {
            if (service.search31APISearchContextDeferred) {
                return service.search31APISearchContextDeferred.promise;
            }

            service.search31APISearchContextDeferred = $q.defer();
            var search31APISearchContextDeferred = service.search31APISearchContextDeferred;

            service.initUserInfoContext().then(function (userContext) {
                var orgId = userContext.Organizations[0].id;
                var url = API_CONFIG.endpoints.SEARCH_CONTEXT_URL + '?callback=searchContextCallback&orgId=' + orgId;// + '&_jstate=' + userContext.conversationId;

                Object.assign(window, {jQuery});

                /*$http.jsonp(url).success(function() {
                }).error(function() {
                    service.search31APISearchContextDeferred.reject('Error');
                });*/
                var xhr = new XMLHttpRequest();
              	xhr.open("GET", url);
              	xhr.setRequestHeader('_jstate', userContext.conversationId);
                xhr.withCredentials = true;
                xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                   if (xhr.status === 200) {
                	  		var script = document.createElement('script');
							script.type = 'text/javascript';
							script.text = xhr.responseText;
							document.getElementsByTagName('head')[0].appendChild(script);
                     }else{
                        service.search31APISearchContextDeferred.reject('Error');
                     }
                  }
                }
                xhr.send();
            }, function () {
                // error handling
            });
            $window.searchContextCallback = searchContextCallback;

            return search31APISearchContextDeferred.promise;
        }

        function searchContextCallback(status, searchContext) {
            service.search31APISearchContextDeferred.resolve(searchContext);
        }
    }

})();



// WEBPACK FOOTER //
// ./app/core/service/OpenlaneService.js